// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"kwGcS","rc-tabs-tab-active":"B50hT","input-suffix":"hM6-l","nav-item":"CMnBK","field":"aXR2t","inline":"Leevi"};